import { TFunction } from "react-i18next";
import * as yup from "yup";

export const validateForm = (
  schemaValue: { password: string, confirmPassword: string },
  translate: TFunction<"translation", undefined>,
  callback: (error: yup.ValidationError[]) => void
) => {
  try {
    const schema = yup.object().shape({
      password: yup
        .string()
        .typeError(translate("pleaseEnterAPassword"))
        .required(translate("pleaseEnterAPassword"))
        .test(
          "min-len",
          translate("yourPasswordMustBeAtLeast6CharactersLong"),
          (password) => !!password && password.length > 6
        )
        .test(
          "max-len",
          translate("yourPasswordMustBeAtMaximumOf30CharactersLong"),
          (password) => !!password && password.length < 30
        ),
      confirmPassword: yup
        .string()
        .typeError(translate("passwordAndConfirmPasswordMustBeTheSame"))
        .oneOf([yup.ref("password"), null], translate("passwordAndConfirmPasswordMustBeTheSame")),
    });

    schema.validateSync(
      {
        password: schemaValue.password,
        confirmPassword: schemaValue.confirmPassword,
      },
      { abortEarly: false }
    );
    callback([]);

    return true;
  } catch (err) {
    if (err instanceof yup.ValidationError) {
      callback(err.inner);
    }

    return false;
  }
};
